import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import DatePicker from '@components/DatePicker';
import TextField from '@components/TextField';
import TimePicker from '@components/TimePicker';
import Icon from '@material-ui/core/Icon';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Alert from '@material-ui/lab/Alert';
import { apiClient } from '@services/api';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

/* ── paleta ───────────────────────────────── */
const C = {
  bg:      '#0f1e35',
  card:    '#172B4D',
  inner:   '#0f2040',
  accent:  '#62DEC2',
  textSec: '#8ba5c4',
  textMain:'#e8f0fb',
  border:  '#1e3a5f',
  danger:  '#ef4444',
};

/* ── componente contador ──────────────────── */
const Counter = ({ value, min = 0, max = 20, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <button
      onClick={() => value > min && onChange(value - 1)}
      disabled={value <= min}
      style={{
        width: 28, height: 28, borderRadius: 6, border: `1px solid ${C.border}`,
        background: value <= min ? 'transparent' : C.inner,
        color: value <= min ? C.border : C.accent,
        cursor: value <= min ? 'default' : 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 18, fontWeight: 700,
      }}
    >−</button>
    <span style={{ color: C.textMain, fontWeight: 600, minWidth: 20, textAlign: 'center' }}>
      {value}
    </span>
    <button
      onClick={() => value < max && onChange(value + 1)}
      disabled={value >= max}
      style={{
        width: 28, height: 28, borderRadius: 6, border: `1px solid ${C.border}`,
        background: value >= max ? 'transparent' : C.inner,
        color: value >= max ? C.border : C.accent,
        cursor: value >= max ? 'default' : 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 18, fontWeight: 700,
      }}
    >+</button>
  </div>
);

const Update = (props) => {
  document.title = `Editar orçamento - ${process.env.REACT_APP_NAME}`;

  const { presales_id } = useParams();
  const history = useHistory();

  const [presale,      setPresale]      = useState(null);
  const [budgets,      setBudgets]      = useState([]);
  const [client,       setClient]       = useState({});
  const [saving,       setSaving]       = useState(false);
  const [error,        setError]        = useState(null);
  const [locked,       setLocked]       = useState(false);
  const [lockReason,   setLockReason]   = useState('');
  const [paidLocked,   setPaidLocked]   = useState(false); // pago: bloqueia add/remover/pax, mas permite editar datas

  // Modal: adicionar serviço
  const [addModal,     setAddModal]     = useState(false);
  const [addType,      setAddType]      = useState('tour');
  const [addSearch,    setAddSearch]    = useState('');
  const [allServices,  setAllServices]  = useState({ tour: [], transfer: [] });
  const [addResults,   setAddResults]   = useState([]);
  const [addSelected,  setAddSelected]  = useState(null);
  const [addAdults,        setAddAdults]        = useState(1);
  const [addKids,          setAddKids]          = useState(0);
  const [addDate,          setAddDate]          = useState(null);
  const [addTransferType,  setAddTransferType]  = useState('Transfer In');
  const [addCodFly,        setAddCodFly]        = useState('');
  const [addTimeFly,       setAddTimeFly]       = useState(null);
  const [addSaving,        setAddSaving]        = useState(false);
  const [addLoading,       setAddLoading]       = useState(false);
  const [availableDates,   setAvailableDates]   = useState([]);
  const [budgetDates,      setBudgetDates]      = useState({}); // { [budgetId]: cupos[] }
  const [addViewMonth,     setAddViewMonth]     = useState(new Date()); // mês visível no calendário do modal

  // Desconto gerencial
  const [discountType,       setDiscountType]       = useState('discount_pct');
  const [discountValue,      setDiscountValue]      = useState('');
  const [discountJustify,    setDiscountJustify]    = useState('');
  const [discountSubmitting, setDiscountSubmitting] = useState(false);
  const [discountError,      setDiscountError]      = useState(null);
  const [discountSuccess,    setDiscountSuccess]    = useState(false);

  // Normaliza valor monetário BR → string com ponto decimal para o backend
  // Ex: "1.000,50" → "1000.50" | "200,00" → "200.00" | "10" → "10"
  const normalizeValue = (val) => {
    const s = val.trim();
    // remove separador de milhar (ponto antes de grupo de 3 dígitos seguido de vírgula)
    const noThousands = s.replace(/\.(?=\d{3}(,|$))/g, '');
    // troca vírgula decimal por ponto
    return noThousands.replace(',', '.');
  };

  const requestManagerDiscount = () => {
    if (!discountValue.trim()) return;
    const normalizedValue = normalizeValue(discountValue);
    if (isNaN(parseFloat(normalizedValue))) {
      setDiscountError('Valor inválido. Use números, ex: 200 ou 1000,00');
      return;
    }
    setDiscountSubmitting(true);
    setDiscountError(null);
    apiClient.httpInstance
      .post(`/presales/${presales_id}/approval/request`, {
        approval_type:    discountType,
        approval_value:   normalizedValue,
        approval_justify: discountJustify.trim() || undefined,
      })
      .then(() => {
        // Redireciona para detalhe onde o status do pedido fica visível
        history.push(`/admin/orcamentos/detalhe/${presales_id}?approval=sent`);
      })
      .catch(err => {
        setDiscountError(err?.response?.data?.error || 'Erro ao solicitar desconto.');
      })
      .finally(() => setDiscountSubmitting(false));
  };

  /* ── carrega presale + budgets ────────── */
  useEffect(() => {
    apiClient.httpInstance.get(`/presales/${presales_id}`).then(res => {
      const p = res.data;
      setPresale(p);
      setClient({
        name:     p.name,
        email:    p.email,
        phone:    p.phone,
        document: p.document,
      });

      // Regras de bloqueio
      if (p.status === 'paid_online' || p.payment_status === 'paid' || p.payment_status === 'partial') {
        setPaidLocked(true); // bloqueio parcial: add/remover/pax bloqueados, mas datas liberadas
        // não retorna: continua carregando para permitir editar datas
      }
      if (p.customer_status === 'approved' && p.status !== 'paid_online' && p.payment_status !== 'paid') {
        setLocked(true);
        setLockReason('Este orçamento foi aprovado pelo cliente e não pode ser editado.');
        return;
      }
      if (p.customer_status === 'refused') {
        setLocked(true);
        setLockReason('Este orçamento foi recusado pelo cliente e não pode ser editado.');
        return;
      }
      if (p.status === 'sold') {
        setLocked(true);
        setLockReason('Este orçamento já foi convertido em venda e não pode ser editado.');
        return;
      }
      if (p.expires_at && new Date(p.expires_at) < new Date()) {
        setLocked(true);
        setLockReason('Este orçamento expirou e não pode ser editado.');
        return;
      }
    });

    apiClient.httpInstance.get(`/presales/${presales_id}/budgets`).then(res => {
      setBudgets(res.data.map(b => ({ ...b })));
    });
  }, [presales_id]);

  /* ── helpers de edição inline ─────────── */
  const updateBudget = (id, field, val) => {
    setBudgets(prev => prev.map(b => b.id === id ? { ...b, [field]: val } : b));
  };

  const removeBudget = (id) => {
    if (!window.confirm('Remover este serviço do orçamento?')) return;
    apiClient.httpInstance.delete(`/presales/${presales_id}/budgets/${id}`)
      .then(() => setBudgets(prev => prev.filter(b => b.id !== id)))
      .catch(() => setError('Erro ao remover serviço. Tente novamente.'));
  };

  /* ── salvar alterações ────────────────── */
  const save = () => {
    setSaving(true);
    apiClient.httpInstance.put(`/presales/${presales_id}/update-values`, {
      reservations: budgets,
      name:  client.name,
      email: client.email,
      phone: client.phone,
    })
      .then(() => history.push(`/admin/orcamentos/detalhe/${presales_id}`))
      .catch(() => {
        setError('Erro ao salvar. Tente novamente.');
        setSaving(false);
      });
  };

  /* ── carrega todos os serviços ao abrir modal ───── */
  useEffect(() => {
    if (!addModal) return;
    const type = addType;
    // já carregou esse tipo
    if (allServices[type === 'tour' ? 'tour' : 'transfer'].length > 0) return;
    setAddLoading(true);
    const endpoint = type === 'tour' ? '/tours' : '/translados';
    apiClient.httpInstance.get(endpoint, { params: { pageSize: 500, array: 'true' } })
      .then(res => {
        const list = res.data?.data ?? res.data ?? [];
        setAllServices(prev => ({ ...prev, [type === 'tour' ? 'tour' : 'transfer']: list }));
      })
      .catch(() => {})
      .finally(() => setAddLoading(false));
  }, [addModal, addType]); // eslint-disable-line

  /* ── filtra client-side ───── */
  useEffect(() => {
    const list = allServices[addType === 'tour' ? 'tour' : 'transfer'];
    if (!addSearch || addSearch.length < 2) {
      setAddResults(list.slice(0, 50));
      return;
    }
    const q = addSearch.toLowerCase();
    const filtered = list.filter(item =>
      (item.name        || '').toLowerCase().includes(q) ||
      (item.region_name || '').toLowerCase().includes(q)
    );
    setAddResults(filtered.slice(0, 50));
  }, [addSearch, addType, allServices]);

  const resetAddModal = () => {
    setAddSearch(''); setAddSelected(null);
    setAddAdults(1); setAddKids(0); setAddDate(null);
    setAddTransferType('Transfer In'); setAddCodFly(''); setAddTimeFly(null);
    setAvailableDates([]);
  };

  // Busca cupos disponíveis ao selecionar um tour (modal de adição)
  useEffect(() => {
    if (!addSelected || addType !== 'tour') { setAvailableDates([]); return; }
    apiClient.httpInstance
      .get(`reservations_dates/available?tour_id=${addSelected.id}`)
      .then(res => setAvailableDates(res.data ?? []))
      .catch(() => setAvailableDates([]));
  }, [addSelected, addType]);

  // Busca cupos para cada tour já existente no orçamento
  useEffect(() => {
    budgets.forEach(b => {
      if (b.travel_type === 'transfer') return;
      const tourId = b.travel_id || b.tour_id;
      if (!tourId || budgetDates[b.id] !== undefined) return;
      apiClient.httpInstance
        .get(`reservations_dates/available?tour_id=${tourId}`)
        .then(res => setBudgetDates(prev => ({ ...prev, [b.id]: res.data ?? [] })))
        .catch(() => setBudgetDates(prev => ({ ...prev, [b.id]: [] })));
    });
  }, [budgets]); // eslint-disable-line

  const disableDateForBudget = (date, budgetId) => {
    const dates = budgetDates[budgetId];
    if (!dates || dates.length === 0) return false; // sem info: não bloqueia
    return !dates.some(d =>
      date.toDateString() === new Date(`${d.cupo_date}T00:00:00`).toDateString() &&
      d.total_cupos > 0
    );
  };

  const disableDates = (date) => {
    if (availableDates.length === 0) return true; // sem info: permite todas
    let hasSlot = false;
    availableDates.forEach(d => {
      if (
        date.toDateString() === new Date(`${d.cupo_date}T00:00:00`).toDateString() &&
        d.total_cupos > 0
      ) { hasSlot = true; }
    });
    return hasSlot;
  };

  const submitAddBudget = () => {
    if (!addSelected) return;
    setAddSaving(true);

    // formata data para string YYYY-MM-DD
    const formatDate = (d) => {
      if (!d) return null;
      if (typeof d === 'string') return d.split('T')[0];
      try { return d.toISOString().split('T')[0]; } catch { return null; }
    };

    const payload = {
      type:               addType,
      service_id:         addSelected.id,
      adults:             addAdults,
      kids:               addType === 'tour' ? addKids : 0,
      tour_date:          formatDate(addDate),
      transfer_type:      addType === 'transfer' ? addTransferType : null,
      cod_fly:            addType === 'transfer' ? addCodFly : null,
      time_fly:           addType === 'transfer' ? (addTimeFly ? (typeof addTimeFly === 'string' ? addTimeFly.slice(0,5) : `${String(addTimeFly.getHours()).padStart(2,'0')}:${String(addTimeFly.getMinutes()).padStart(2,'0')}`) : null) : null,
    };

    apiClient.httpInstance.post(`/presales/${presales_id}/budgets`, payload)
      .then(res => {
        // Mescla o retorno da API com os dados do formulário para exibir imediatamente
        const newBudget = {
          ...res.data.budget,
          tour_date:     payload.tour_date,
          cod_fly:       payload.cod_fly,
          time_fly:      payload.time_fly,
          transfer_type: payload.transfer_type,
        };
        setBudgets(prev => [...prev, newBudget]);
        setAddModal(false);
        resetAddModal();
      })
      .catch(() => setError('Erro ao adicionar serviço.'))
      .finally(() => setAddSaving(false));
  };

  const breadcrumbs = [
    { title: 'Início', active: true, route: '/admin/orcamentos' },
    { title: `Orçamento ${client.name ?? ''}`, active: true, route: `/admin/orcamentos/detalhe/${presales_id}` },
    { title: 'Edição' },
  ];

  const inputStyle = {
    background: C.inner, border: `1px solid ${C.border}`, borderRadius: 6,
    padding: '6px 10px', color: C.textMain, fontSize: 13, outline: 'none', width: '100%',
    boxSizing: 'border-box',
  };

  return (
    <>
      <BreadCrumbs items={breadcrumbs} />
      <div style={{ padding: '24px 28px', background: C.bg, minHeight: '100vh' }}>

        {/* Banner de bloqueio total */}
        {locked && (
          <div style={{
            background: '#7f1d1d', border: `1px solid ${C.danger}`, borderRadius: 10,
            padding: '14px 20px', marginBottom: 20, color: '#fecaca', fontSize: 14,
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <Icon style={{ fontSize: 20 }}>lock</Icon>
            {lockReason}
          </div>
        )}

        {/* Banner de bloqueio parcial (pago) */}
        {paidLocked && !locked && (
          <div style={{
            background: '#1a3a5a', border: `1px solid #62DEC2`, borderRadius: 10,
            padding: '14px 20px', marginBottom: 20, color: '#bfdbfe', fontSize: 14,
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <Icon style={{ fontSize: 20, color: '#62DEC2' }}>payments</Icon>
            Pagamento recebido — não é possível adicionar/remover serviços nem alterar passageiros. Edição de datas permitida.
          </div>
        )}

        {error && (
          <div style={{
            background: '#7f1d1d', border: `1px solid ${C.danger}`, borderRadius: 10,
            padding: '12px 16px', marginBottom: 16, color: '#fecaca', fontSize: 13,
          }}>
            {error}
          </div>
        )}

        <h2 style={{ color: C.textMain, fontSize: 20, fontWeight: 700, marginBottom: 20 }}>
          Edição do orçamento
        </h2>

        {/* ── Serviços ─────────────────────────────── */}
        <div style={{ background: C.card, borderRadius: 12, marginBottom: 16, overflow: 'hidden' }}>
          <div style={{
            padding: '14px 20px', borderBottom: `1px solid ${C.border}`,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <span style={{ color: C.textMain, fontWeight: 700, fontSize: 14 }}>
              Serviços incluídos
            </span>
            {!locked && !paidLocked && (
              <button
                onClick={() => { setAddModal(true); setAddType('tour'); setAddSearch(''); setAddSelected(null); }}
                style={{
                  background: C.accent, border: 'none', borderRadius: 8,
                  padding: '6px 16px', color: '#0f1e35', fontWeight: 700,
                  fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
                }}
              >
                <Icon style={{ fontSize: 16 }}>add</Icon>
                Adicionar serviço
              </button>
            )}
          </div>

          {budgets.length === 0 ? (
            <div style={{ padding: 32, textAlign: 'center', color: C.textSec, fontSize: 13 }}>
              Nenhum serviço. Adicione pelo menos um.
            </div>
          ) : budgets.map((b, i) => (
            <div key={b.id} style={{
              padding: '16px 20px',
              borderBottom: i < budgets.length - 1 ? `1px solid ${C.border}` : 'none',
            }}>
              {/* Nome do serviço */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
                <div>
                  <span style={{ color: C.accent, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>
                    {b.travel_type === 'transfer' ? 'Transfer' : 'Passeio'}
                  </span>
                  <div style={{ color: C.textMain, fontWeight: 600, fontSize: 15, marginTop: 2 }}>
                    {b.travel_name ?? b.transfer_type ?? `Serviço #${b.id}`}
                  </div>
                </div>
                {!locked && !paidLocked && (
                  <button
                    onClick={() => removeBudget(b.id)}
                    style={{
                      background: 'transparent', border: `1px solid ${C.danger}`,
                      borderRadius: 6, padding: '4px 10px', color: C.danger,
                      cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 4,
                    }}
                  >
                    <Icon style={{ fontSize: 14 }}>delete</Icon>
                    Remover
                  </button>
                )}
              </div>

              {/* Campos editáveis */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16 }}>
                {/* Data + voo — transfer */}
                {b.travel_type === 'transfer' && (
                  <>
                    <div>
                      <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                        Tipo
                      </label>
                      {locked ? (
                        <span style={{ color: C.textMain, fontSize: 13 }}>{b.transfer_type || '—'}</span>
                      ) : (
                        <RadioGroup
                          row
                          value={b.transfer_type || 'Transfer In'}
                          onChange={e => updateBudget(b.id, 'transfer_type', e.target.value)}
                        >
                          <FormControlLabel value="Transfer In"  control={<Radio style={{ color: C.accent }} />} label={<span style={{ color: C.textMain, fontSize: 13 }}>Transfer In</span>} />
                          <FormControlLabel value="Transfer Out" control={<Radio style={{ color: C.accent }} />} label={<span style={{ color: C.textMain, fontSize: 13 }}>Transfer Out</span>} />
                        </RadioGroup>
                      )}
                    </div>
                    <div>
                      <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                        Data do transfer
                      </label>
                      {locked ? (
                        <span style={{ color: C.textMain, fontSize: 13 }}>
                          {b.tour_date ? b.tour_date.slice(0, 10).split('-').reverse().join('/') : '—'}
                        </span>
                      ) : (
                        <DatePicker
                          label=""
                          value={b.tour_date ? new Date(`${b.tour_date.slice(0, 10)}T00:00:00`) : null}
                          onChange={date => {
                            if (!date) return;
                            updateBudget(b.id, 'tour_date', date.toISOString().split('T')[0]);
                          }}
                        />
                      )}
                    </div>
                    <div>
                      <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                        Nº do voo
                      </label>
                      {locked ? (
                        <span style={{ color: C.textMain, fontSize: 13 }}>{b.cod_fly || '—'}</span>
                      ) : (
                        <input
                          value={b.cod_fly ?? ''}
                          onChange={e => updateBudget(b.id, 'cod_fly', e.target.value)}
                          placeholder="ex: LA 704"
                          style={{ background: C.inner, border: `1px solid ${C.border}`, borderRadius: 6, padding: '6px 10px', color: C.textMain, fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' }}
                        />
                      )}
                    </div>
                    <div>
                      <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                        Horário do voo
                      </label>
                      {locked ? (
                        <span style={{ color: C.textMain, fontSize: 13 }}>{b.time_fly || '—'}</span>
                      ) : (
                        <TimePicker
                          label=""
                          value={b.time_fly ? new Date(`1970-01-01T${b.time_fly.slice(0,5).length === 5 ? b.time_fly.slice(0,5) : '00:00'}:00`) : null}
                          onChange={date => {
                            if (!date) return;
                            const hh = String(date.getHours()).padStart(2, '0');
                            const mm = String(date.getMinutes()).padStart(2, '0');
                            updateBudget(b.id, 'time_fly', `${hh}:${mm}`);
                          }}
                        />
                      )}
                    </div>
                  </>
                )}
                {/* Data — com verificação de cupos (passeios) */}
                {b.travel_type !== 'transfer' && (
                  <div>
                    <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                      Data do passeio
                    </label>
                    {locked ? (
                      <span style={{ color: C.textMain, fontSize: 13 }}>
                        {b.tour_date ? b.tour_date.slice(0, 10).split('-').reverse().join('/') : '—'}
                      </span>
                    ) : (
                      <DatePicker
                        label=""
                        value={b.tour_date ? new Date(`${b.tour_date.slice(0, 10)}T00:00:00`) : null}
                        onChange={date => {
                          if (!date) return;
                          const iso = date.toISOString().split('T')[0];
                          updateBudget(b.id, 'tour_date', iso);
                        }}
                        shouldDisableDate={date => disableDateForBudget(date, b.id)}
                        disablePast
                      />
                    )}
                    {b.tour_date && budgetDates[b.id] && (() => {
                      const sel = budgetDates[b.id].find(d => d.cupo_date === b.tour_date.slice(0, 10));
                      if (!sel) return null;
                      const cor = sel.total_cupos <= 3 ? '#f87171' : sel.total_cupos <= 7 ? '#f59e0b' : '#62DEC2';
                      return (
                        <span style={{ color: cor, fontSize: 10, marginTop: 3, display: 'block' }}>
                          {sel.total_cupos} cupo{sel.total_cupos !== 1 ? 's' : ''} disponíve{sel.total_cupos !== 1 ? 'is' : 'l'} nesta data
                        </span>
                      );
                    })()}
                    {budgetDates[b.id] !== undefined && budgetDates[b.id].length === 0 && (
                      <span style={{ color: '#f59e0b', fontSize: 10, marginTop: 3, display: 'block' }}>
                        ⚠ Sem datas disponíveis no sistema
                      </span>
                    )}
                  </div>
                )}

                {/* Adultos */}
                <div>
                  <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                    Adultos
                  </label>
                  {locked || paidLocked
                    ? <span style={{ color: C.textMain }}>{b.adults_total}</span>
                    : <Counter
                        value={parseInt(b.adults_total) || 0}
                        min={b.travel_type === 'transfer' ? 1 : 0}
                        onChange={val => updateBudget(b.id, 'adults_total', val)}
                      />
                  }
                  {b.adults_total > 0 && b.adults_total_amount > 0 && (
                    <span style={{ color: C.textSec, fontSize: 11, marginTop: 4, display: 'block' }}>
                      {process.env.REACT_APP_CURRENCY} {(b.adults_total_amount / b.adults_total).toFixed(2).replace('.', ',')} /pessoa
                    </span>
                  )}
                </div>

                {/* Crianças (só passeios) */}
                {b.travel_type !== 'transfer' && (
                  <div>
                    <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                      Crianças
                    </label>
                    {/* Bloqueia counter se: locked, paidLocked, ou tour com kids_allowed = false */}
                    {(locked || paidLocked || b.kids_allowed === false || b.kids_allowed === 0)
                      ? (
                        <>
                          <span style={{ color: C.textMain }}>{b.kids_total ?? 0}</span>
                          {(b.kids_allowed === false || b.kids_allowed === 0) && !locked && !paidLocked && (
                            <span style={{ color: C.textSec, fontSize: 10, marginTop: 3, display: 'block' }}>
                              Não aceita crianças
                            </span>
                          )}
                        </>
                      )
                      : <Counter
                          value={parseInt(b.kids_total) || 0}
                          onChange={val => updateBudget(b.id, 'kids_total', val)}
                        />
                    }
                    {b.kids_total > 0 && b.kids_total_amount > 0 && (
                      <span style={{ color: C.textSec, fontSize: 11, marginTop: 4, display: 'block' }}>
                        {process.env.REACT_APP_CURRENCY} {(b.kids_total_amount / b.kids_total).toFixed(2).replace('.', ',')} /criança
                      </span>
                    )}
                  </div>
                )}

                {/* Desconto automático por região */}
                <div>
                  <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                    Desc. automático
                  </label>
                  <span style={{ fontSize: 11, color: '#6e8eb0' }}>
                    {b.travel_type === 'transfer' ? '—' : (
                      ['santiago','atacama'].includes((b.region_name || b.travel_region || '').toLowerCase())
                        ? 'PIX 12% / Cartão 10%'
                        : 'PIX 7% / Cartão 5%'
                    )}
                  </span>
                  {b.adults_operational_cost > 0 && (
                    <span style={{ color: C.textSec, fontSize: 10, marginTop: 4, display: 'block' }}>
                      custo: {process.env.REACT_APP_CURRENCY} {Number(b.adults_operational_cost).toFixed(2).replace('.', ',')} /adulto
                    </span>
                  )}
                </div>

                {/* Total */}
                <div>
                  <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                    Total
                  </label>
                  <span style={{ color: C.accent, fontWeight: 700, fontSize: 15 }}>
                    {process.env.REACT_APP_CURRENCY} {Number(b.total_amount || 0).toFixed(2).replace('.', ',')}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Dados do cliente (editável) ───── */}
        <div style={{ background: C.card, borderRadius: 12, marginBottom: 24, padding: '16px 20px' }}>
          <div style={{ color: C.textSec, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 14 }}>
            Dados do cliente
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            {[
              { key: 'name',  label: 'Nome',     type: 'text'  },
              { key: 'email', label: 'E-mail',   type: 'email' },
              { key: 'phone', label: 'Telefone', type: 'text'  },
            ].map(({ key, label, type }) => (
              <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  {label}
                </label>
                <input
                  type={type}
                  value={client[key] ?? ''}
                  disabled={locked}
                  onChange={e => setClient(prev => ({ ...prev, [key]: e.target.value }))}
                  style={{
                    background: C.cardInner ?? '#0f1c2e',
                    border: `1px solid ${C.sep ?? '#1a3050'}`,
                    borderRadius: 8,
                    padding: '8px 12px',
                    color: locked ? C.textSec : C.textMain,
                    fontSize: 13,
                    outline: 'none',
                    width: '100%',
                    boxSizing: 'border-box',
                    cursor: locked ? 'not-allowed' : 'text',
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* ── Solicitar aprovação gerencial ────────── */}
        {!presale?.approval_status && presale?.status !== 'canceled' && (
          <div style={{ background: C.card, borderRadius: 12, marginBottom: 24, padding: '16px 20px' }}>
            <div style={{ color: '#F5C842', fontSize: 13, fontWeight: 700, marginBottom: 14 }}>
              ★ Solicitar aprovação gerencial
            </div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
              <div style={{ flex: 2, minWidth: 200 }}>
                <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>Tipo de solicitação</label>
                <select
                  value={discountType}
                  onChange={e => setDiscountType(e.target.value)}
                  style={{ width: '100%', background: C.inner, border: `1px solid ${C.border}`, borderRadius: 8, padding: '10px 12px', color: C.textMain, fontSize: 13, outline: 'none' }}
                >
                  <option value="discount_pct">Desconto em % (percentual)</option>
                  <option value="discount_value">Desconto em valor (R$)</option>
                  <option value="installment">Parcelamento sem juros</option>
                </select>
              </div>
              <div style={{ flex: 1, minWidth: 120 }}>
                <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
                  Valor ({discountType === 'discount_pct' ? '%' : discountType === 'discount_value' ? 'R$' : 'x'})
                </label>
                <input
                  type="text"
                  value={discountValue}
                  onChange={e => setDiscountValue(e.target.value)}
                  placeholder={discountType === 'discount_pct' ? 'ex: 10' : discountType === 'discount_value' ? 'ex: 200' : 'ex: 6'}
                  style={{ width: '100%', boxSizing: 'border-box', background: C.inner, border: `1px solid ${C.border}`, borderRadius: 8, padding: '10px 12px', color: C.textMain, fontSize: 13, outline: 'none' }}
                />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: C.textSec, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>Justificativa</label>
              <textarea
                value={discountJustify}
                onChange={e => setDiscountJustify(e.target.value)}
                placeholder="Por que está solicitando essa condição especial?"
                rows={2}
                style={{ width: '100%', boxSizing: 'border-box', background: C.inner, border: `1px solid ${C.border}`, borderRadius: 8, padding: '10px 12px', color: C.textMain, fontSize: 13, outline: 'none', resize: 'vertical' }}
              />
            </div>
            {discountError && (
              <div style={{ background: '#450a0a', border: '1px solid #ef4444', borderRadius: 8, padding: '8px 12px', color: '#fca5a5', fontSize: 13, marginBottom: 12 }}>
                {discountError}
              </div>
            )}
            {discountSuccess && (
              <div style={{ background: '#052e16', border: '1px solid #22c55e', borderRadius: 8, padding: '8px 12px', color: '#86efac', fontSize: 13, marginBottom: 12 }}>
                ✓ Pedido enviado com sucesso! Aguardando aprovação gerencial.
              </div>
            )}
            <button
              onClick={requestManagerDiscount}
              disabled={!discountValue.trim() || discountSubmitting}
              style={{ background: 'transparent', border: `1px solid ${C.accent}`, borderRadius: 8, padding: '8px 20px', color: C.accent, fontWeight: 600, fontSize: 13, cursor: (!discountValue.trim() || discountSubmitting) ? 'not-allowed' : 'pointer', opacity: (!discountValue.trim() || discountSubmitting) ? 0.6 : 1 }}
            >
              ▶ {discountSubmitting ? 'Enviando...' : 'Enviar pedido'}
            </button>
          </div>
        )}

        {/* ── Botões ──────────────────────────────── */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, flexWrap: 'wrap' }}>
          <Button
            textcolor={C.textSec}
            padding="8px 20px"
            variant="outlined"
            bgColor="transparent"
            onClick={() => history.push(`/admin/orcamentos/detalhe/${presales_id}`)}
          >
            <Icon style={{ fontSize: 16, marginRight: 6 }}>arrow_back</Icon>
            Cancelar
          </Button>
{!locked && (
            <Button
              textcolor="#0f1e35"
              padding="8px 24px"
              customcolor={C.accent}
              onClick={save}
              disabled={saving}
            >
              {saving ? 'Salvando...' : 'Salvar alterações'}
            </Button>
          )}
        </div>
      </div>

      {/* ── Modal: adicionar serviço ─────────────── */}
      {addModal && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            background: C.card, borderRadius: 16, padding: '28px 24px',
            width: 480, maxWidth: '92vw', maxHeight: '85vh',
            display: 'flex', flexDirection: 'column', gap: 16,
            boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: C.textMain, fontWeight: 700, fontSize: 16 }}>
                Adicionar serviço
              </span>
              <button onClick={() => setAddModal(false)} style={{ background: 'none', border: 'none', color: C.textSec, cursor: 'pointer' }}>
                <Icon>close</Icon>
              </button>
            </div>

            {/* Tipo */}
            <div style={{ display: 'flex', gap: 8 }}>
              {['tour', 'transfer'].map(t => (
                <button
                  key={t}
                  onClick={() => { setAddType(t); setAddSearch(''); setAddSelected(null); setAddDate(null); setAddCodFly(''); setAddTimeFly(null); }}
                  style={{
                    flex: 1, padding: '8px', borderRadius: 8, cursor: 'pointer',
                    border: `1px solid ${addType === t ? C.accent : C.border}`,
                    background: addType === t ? `${C.accent}22` : C.inner,
                    color: addType === t ? C.accent : C.textSec,
                    fontWeight: 600, fontSize: 13, textTransform: 'capitalize',
                  }}
                >
                  {t === 'tour' ? 'Passeio' : 'Transfer'}
                </button>
              ))}
            </div>

            {/* Busca */}
            <div>
              <label style={{ color: C.textSec, fontSize: 12, display: 'block', marginBottom: 6 }}>
                Buscar {addType === 'tour' ? 'passeio' : 'transfer'}
              </label>
              <input
                value={addSearch}
                onChange={e => { setAddSearch(e.target.value); setAddSelected(null); }}
                placeholder={`Nome do ${addType === 'tour' ? 'passeio' : 'transfer'}...`}
                style={inputStyle}
              />
            </div>

            {/* Resultados */}
            {addLoading && (
              <p style={{ color: C.textSec, fontSize: 12, textAlign: 'center', margin: 0 }}>
                Carregando serviços...
              </p>
            )}
            {!addLoading && !addSelected && (
              <div style={{
                background: C.inner, borderRadius: 8, border: `1px solid ${C.border}`,
                maxHeight: 200, overflowY: 'auto',
              }}>
                {addResults.length === 0 ? (
                  <p style={{ color: C.textSec, fontSize: 12, padding: '10px 14px', margin: 0 }}>
                    {addSearch.length >= 2 ? 'Nenhum resultado encontrado.' : 'Digite para filtrar...'}
                  </p>
                ) : addResults.map(r => (
                  <div
                    key={r.id}
                    onClick={() => { setAddSelected(r); setAddSearch(r.name ?? r.region_name ?? ''); if (r.kids_allowed === false || r.kids_allowed === 0) setAddKids(0); }}
                    style={{
                      padding: '10px 14px', cursor: 'pointer', color: C.textMain, fontSize: 13,
                      borderBottom: `1px solid ${C.border}`,
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#1e3a5f'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{ color: C.accent, fontSize: 10, marginRight: 6, textTransform: 'uppercase' }}>
                      {r.region_name ?? ''}
                    </span>
                    {r.name ?? r.region_name ?? `#${r.id}`}
                  </div>
                ))}
              </div>
            )}

            {addSelected && (
              <>
                {/* ── PASSEIO: data ── */}
                {addType === 'tour' && (
                  <>
                    <DatePicker
                      label="Data do passeio"
                      value={addDate}
                      onChange={date => setAddDate(date)}
                      onMonthChange={date => setAddViewMonth(date)}
                      shouldDisableDate={date => !disableDates(date)}
                      disablePast
                    />
                    {/* Alerta Alyan/Monteluz no mês vigente */}
                    {(addSelected?.id === 58 || addSelected?.id === 139) &&
                      addViewMonth.getMonth() === new Date().getMonth() &&
                      addViewMonth.getFullYear() === new Date().getFullYear() && (
                      <div style={{
                        background: '#2a1a0d', border: '1px solid #d97706',
                        borderRadius: 10, padding: '12px 14px', marginTop: 4,
                        color: '#FCD34D', fontSize: 12, lineHeight: 1.6,
                      }}>
                        ⚠️ <strong>Este tour não pode ser reservado neste mês pelo orçamento atual.</strong><br />
                        Faça um novo orçamento exclusivo com os tours de pagamento PIX no mês vigente.
                      </div>
                    )}
                  </>
                )}

                {/* ── TRANSFER: tipo In/Out + data + voo ── */}
                {addType === 'transfer' && (
                  <>
                    <div>
                      <label style={{ color: C.textSec, fontSize: 12, display: 'block', marginBottom: 4 }}>Tipo</label>
                      <RadioGroup
                        row
                        value={addTransferType}
                        onChange={e => setAddTransferType(e.target.value)}
                      >
                        <FormControlLabel value="Transfer In"  control={<Radio style={{ color: C.accent }} />} label={<span style={{ color: C.textMain, fontSize: 13 }}>Transfer In</span>} />
                        <FormControlLabel value="Transfer Out" control={<Radio style={{ color: C.accent }} />} label={<span style={{ color: C.textMain, fontSize: 13 }}>Transfer Out</span>} />
                      </RadioGroup>
                    </div>
                    <DatePicker
                      label="Data do transfer"
                      value={addDate}
                      onChange={date => setAddDate(date)}
                    />
                    <div style={{ display: 'flex', gap: 12 }}>
                      <div style={{ flex: 1 }}>
                        <TextField
                          className="inputRounded"
                          label="Código do voo"
                          variant="outlined"
                          type="text"
                          value={addCodFly}
                          onChange={e => setAddCodFly(e.target.value)}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <TimePicker
                          label="Horário do voo"
                          value={addTimeFly}
                          onChange={time => setAddTimeFly(time)}
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* Passageiros */}
                <div style={{ display: 'flex', gap: 24 }}>
                  <div>
                    <label style={{ color: C.textSec, fontSize: 12, display: 'block', marginBottom: 8 }}>Adultos</label>
                    <Counter value={addAdults} min={1} onChange={setAddAdults} />
                    {addSelected?.price > 0 && (
                      <span style={{ color: C.textSec, fontSize: 11, marginTop: 4, display: 'block' }}>
                        {process.env.REACT_APP_CURRENCY} {Number(addSelected.price).toFixed(2).replace('.', ',')} /adulto
                      </span>
                    )}
                  </div>
                  {addType === 'tour' && (
                    <div>
                      <label style={{ color: C.textSec, fontSize: 12, display: 'block', marginBottom: 8 }}>Crianças</label>
                      {(addSelected?.kids_allowed === false || addSelected?.kids_allowed === 0) ? (
                        <span style={{ color: C.textSec, fontSize: 12 }}>Não aceita crianças</span>
                      ) : (
                        <>
                          <Counter value={addKids} onChange={setAddKids} />
                          {addSelected?.kids_price > 0 && (
                            <span style={{ color: C.textSec, fontSize: 11, marginTop: 4, display: 'block' }}>
                              R$ {Number(addSelected.kids_price).toFixed(2).replace('.', ',')} /criança
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Total preview + info desconto automático */}
                {(() => {
                  const baseAdults = addAdults * (addSelected?.price ?? 0)
                  const baseKids   = addKids   * (addSelected?.kids_price ?? 0)
                  const base = baseAdults + baseKids
                  return base > 0 ? (
                    <div style={{ display: 'flex', gap: 24, alignItems: 'flex-end' }}>
                      <div>
                        <label style={{ color: C.textSec, fontSize: 12, display: 'block', marginBottom: 6 }}>Total</label>
                        <span style={{ color: C.accent, fontWeight: 700, fontSize: 16 }}>
                          {process.env.REACT_APP_CURRENCY} {base.toFixed(2).replace('.', ',')}
                        </span>
                      </div>
                      {addType === 'tour' && (
                        <div>
                          <label style={{ color: C.textSec, fontSize: 12, display: 'block', marginBottom: 6 }}>Desc. automático</label>
                          <span style={{ fontSize: 11, color: '#6e8eb0' }}>
                            {['santiago','atacama'].includes((addSelected?.region_name || '').toLowerCase())
                              ? 'PIX 12% / Cartão 10%'
                              : 'PIX 7% / Cartão 5%'}
                          </span>
                        </div>
                      )}
                    </div>
                  ) : null
                })()}

                <button
                  onClick={submitAddBudget}
                  disabled={addSaving}
                  style={{
                    background: C.accent, border: 'none', borderRadius: 10,
                    padding: '12px', color: '#0f1e35', fontWeight: 700,
                    fontSize: 14, cursor: addSaving ? 'not-allowed' : 'pointer',
                    opacity: addSaving ? 0.7 : 1,
                  }}
                >
                  {addSaving ? 'Adicionando...' : 'Confirmar e adicionar'}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Update;
